
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/matheus-wichman-joining",
      function () {
        return require("private-next-pages/blog/matheus-wichman-joining.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/matheus-wichman-joining"])
      });
    }
  